<template>
  <form>
    <h4 class="card-title"></h4>
    <div class="col-lg-12">

          <!--<div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_esms_questionnaire')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionFullProposalEsmsQuestionnaire" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionFullProposalEsmsQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionFullProposalEsmsQuestionnaire"></upload-file>
            </div>
          </div>-->

          <div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_applicant_declaration')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionFullProposalApplicantDeclaration" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionFullProposalApplicantDeclaration" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionFullProposalApplicantDeclaration"></upload-file>
            </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_coapplicant_declaration')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionFullProposalCoapplicantDeclarationDocument" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionFullProposalCoapplicantDeclarationDocument" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionFullProposalCoapplicantDeclarationDocument"></upload-file>
            </div>
          </div>
          
      
      
    </div>
    
      <div class="row">
      <div class="col-lg-12">
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.revisionModel.technical.otherDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['revisionOtherDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['revisionOtherDocuments' + (index+1)]"
                  :is-editable="GrantForm.isRevisionEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.revisionOtherDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: []
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.revisionModel.technical.otherDocuments)
        {
          GrantForm.revisionModel.technical.otherDocuments = [];
        }

        GrantForm.revisionModel.technical.otherDocuments.push({});
        this.$forceUpdate();
      },

      /*addOtherEsmsDocument()
      {
        if (!GrantForm.model.cndocuments.cnEsmsOtherDocs)
        {
          GrantForm.model.cndocuments.cnEsmsOtherDocs = [];
        }

        GrantForm.model.cndocuments.cnEsmsOtherDocs.push({});
        this.$forceUpdate();
      },*/
      addNewSupportingDocument(subgroup, group_index)
            {
                const last_index = subgroup.cnOtherDocs.length;

                subgroup.cnOtherDocs.push({
                    key: 'support_document_custom_' + group_index + '_' + last_index + '_' + (+new Date()),
                    title: '',
                });

                this.$forceUpdate();
            },
            removeSupportField(subgroup, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_field')))
                {
                    subgroup.splice(index, 1);
                }
            },
      fileAdded(file) {
                EventBus.$emit('wizard-save-progress');
      }
    },
    mounted() {
      if (GrantForm.model.technical.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.model.technical.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.model.technical.orgCoApplicants = value;
      }
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  .inline{
    display: flex;
  justify-content: space-between;
  }

  .inline p{
width: 50%;
margin-right: 10px;
  }
</style>
